import { Vue, Component, Ref, Prop, Emit } from 'vue-property-decorator'
import AttachmentsTree from '@/modules/viewerModule/attachmentsTree/AttachmentsTree.vue'
import { initialToolboxState, IToolboxState } from './Toolbox.models'
import { ToolType } from '../viewer/tools/Tool'
import ViewerComponent from '@/modules/viewerModule/viewer/Viewer'
import AboutModal from '@/components/help/AboutModal.vue'
import ShortcutsAndVoiceCommands from '@/components/help/shortcutsAndVoiceCommands/ShortcutsAndVoiceCommandsModal.vue'

@Component({
    components: { AttachmentsTree, AboutModal, ShortcutsAndVoiceCommands }
})
export default class ToolboxComponent extends Vue {
    private viewer: ViewerComponent | undefined
    private selectedTool: ToolType
    protected get userLastProfileImage(): string | undefined {
        return this.$store.getters.userLastProfileImage
    }

    @Ref('colorPopover') readonly colorPopover!: any

    @Ref('helpPopover') readonly helpPopover!: any
    @Ref('aboutModal') readonly aboutModal!: any
    @Ref('shortcutsAndVoiceCommands') readonly shortcutsAndVoiceCommands!: any
    @Prop() selectedColor!: string

    state: IToolboxState
    constructor() {
        super()
        this.state = initialToolboxState()
        this.selectedTool = ToolType.MOVE
    }

    protected mounted(): void {
        document.addEventListener('fullscreenchange', this.onFullScreenChange, false)
        document.addEventListener('webkitfullscreenchange', this.onFullScreenChange, false)
        document.addEventListener('mozfullscreenchange', this.onFullScreenChange, false)
        document.addEventListener('keydown', this.onKeyDownCheckF11, false)
    }

    protected unmounted(): void {
        document.removeEventListener('fullscreenchange', this.onFullScreenChange, false)
        document.removeEventListener('webkitfullscreenchange', this.onFullScreenChange, false)
        document.removeEventListener('mozfullscreenchange', this.onFullScreenChange, false)
        document.removeEventListener('keydown', this.onKeyDownCheckF11, false)
    }

    // if F11 has been pressed, call the fullscreen api requestFullscreen method
    // and return false, disabling the default browser functionality
    private onKeyDownCheckF11(event:KeyboardEvent):boolean {
        if (event.code === 'F11') {
            // we need to do this if we want to listen the change to modify the fullscreen button icon
            this.openFullscreen()
            return false
        }
        return true
    }

    protected onToolSelected(type: keyof typeof ToolType): void {
        const tool: ToolType = ToolType[type]
        this.selectedTool = tool
        this.viewer?.changeTool(tool)
    }

    public resendCurrentTool(): void {
        this.viewer?.changeTool(this.selectedTool)
    }

    public changeTool(tool: ToolType): void {
        this.selectedTool = tool
    }

    @Emit('changeColor')
    protected changeColor(color: string): void {
        this.selectedColor = color
    }

    protected zoomIn(): void {
        this.viewer!.zoomIn()
    }

    protected abortAction(): void {
        this.viewer!.abortAction()
    }

    protected zoomOut(): void {
        this.viewer!.zoomOut()
    }

    protected openFullscreen(): void {
        const body = <any>document.body

        if (body.requestFullscreen) {
            body.requestFullscreen()
        } else if (body.mozRequestFullScreen) { /* Firefox */
            body.mozRequestFullScreen()
        } else if (body.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
            body.webkitRequestFullscreen()
        } else if (body.msRequestFullscreen) { /* IE/Edge */
            body.msRequestFullscreen()
        }
    }

    protected onFullScreenChange(): void {
        const anyDocument = <any>document
        if (anyDocument.webkitIsFullScreen ||
            anyDocument.mozFullScreen ||
            anyDocument.msFullscreenElement) {
            this.state.isFullscreen = true
        } else {
            this.state.isFullscreen = false
        }
    }

    protected closeFullscreen(): void {
        try {
            if (document.exitFullscreen) {
                document.exitFullscreen()
            } else if ((<any>document).mozCancelFullScreen) { /* Firefox */
                (<any>document).mozCancelFullScreen()
            } else if ((<any>document).webkitExitFullscreen) { /* Chrome, Safari and Opera */
                (<any>document).webkitExitFullscreen()
            } else if ((<any>document).msExitFullscreen) { /* IE/Edge */
                (<any>document).msExitFullscreen()
            }
        } catch (error) {
            // ignoring the error as it is possible we tried to close an already closed full screen
        }

        this.state.isFullscreen = false
    }

    protected originalZoom(): void {
        this.viewer!.originalZoom()
    }

    public setViewer(viewer: ViewerComponent): void {
        this.viewer = viewer
        this.state.showMeasureButtons = this.viewer.showMeasureButtons
        this.state.showSaveButton = this.viewer.showSaveButton
    }

    protected panMap(event: any): void {
        this.viewer?.panMap(event.srcKey)
    }

    protected showPictureInfo(): void {
        this.viewer?.showPictureInfo()
    }

    protected requestSave(): void {
        this.viewer?.requestSave()
    }

    protected showConfiguration(): void {
        this.viewer?.showConfiguration()
    }

    protected toogleMap(): void {
        this.state.showMap = !this.state.showMap
        this.viewer?.toogleMap()
    }

    protected toogleFx(): void {
        this.state.showFx = !this.state.showFx
        this.viewer?.toogleFx()
    }

    public setShowMap(showMap: boolean): void {
        this.state.showMap = showMap
    }

    public setShowFx(showFx: boolean): void {
        this.state.showFx = showFx
    }

    public toogleAttachments(): void {
        this.state.showAttachments = !this.state.showAttachments
        this.emitOnToogleAttachments(this.state.showAttachments)
    }

    @Emit('onToogleAttachments')
    private emitOnToogleAttachments(showAttachments: boolean): void { }
}
